import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon, Table } from 'react-bootstrap';

require('./experiment.css');

/**
 * React component used to display the list of bioSAXS experiments performed for a given session
 */
export class ExperimentPanel extends React.Component {
    render() {
        return (<div
            className='experimentPanel'
            style={{ backgroundColor: (this.props.backgroundColorCode && this.props.backgroundColorCode === 1) ? '#fafafa' : '#ffffff' }}
            onClick={() => this.props.onExperimentClicked(this.props)}>
            <div
                className={this.props.isSelected ? 'selectedExperiment' : null}
                style={{ borderTop: '1px solid #cecece', paddingLeft: '8px', paddingTop: '4px' }}
            >
                <ExperimentType {...this.props} /> <a href={this.props.downloadURL} > <Glyphicon glyph="download" /> </a >
                <br />
                <span style={{ fontSize: '11px' }}> {this.props.creationDate} </span>
                <br />
                <span style={{ fontSize: '11px' }}>   {this.props.name}</span>
                <br />

                <Table id='experimentTable' responsive style={{ paddingLeft: '8px' }}>
                    <tbody>
                        <ExperimentStatisticBar experimentType={this.props.experimentType} firstColumnText='Samples' numberOf={this.props.measurementDoneCount} totalOf={this.props.measurementCount} />
                        <ExperimentStatisticBar experimentType={this.props.experimentType} firstColumnText='Averages' numberOf={this.props.measurementAveragedCount} totalOf={this.props.measurementCount} />
                        <ExperimentStatisticBar experimentType={this.props.experimentType} firstColumnText='Subtractions' numberOf={this.props.dataCollectionDoneCount} totalOf={this.props.dataCollectionCount} />
                    </tbody>
                </Table>

            </div>

        </div>);
    }
}

/** React componenent used to render the experiment type */
const ExperimentType = (props) => {
    if (props.experimentType === 'CALIBRATION') {
        return <span className='textInColoredSpan' style={{ backgroundColor: '#2E9AFE' }}>{props.experimentType}</span>
    } else if (props.experimentType === 'STATIC') {
        return <span className='textInColoredSpan' style={{ backgroundColor: '#088A08' }}>{props.experimentType}</span>
    } else if (props.experimentType === 'HPLC') {
        return <span className='textInColoredSpan' style={{ backgroundColor: '#AC58FA' }}>{props.experimentType}</span>
    } else return <span> NA</span>
}

/** React component used to render a experiment statistic bar */
const ExperimentStatisticBar = (props) => {
    let barWidth = Math.round(props.numberOf / props.totalOf * 100).toString() + '%';
    if (props.experimentType === 'CALIBRATION'
        || props.experimentType === 'STATIC'
        || (props.experimentType === 'HPLC' && props.firstColumnText === 'Subtractions')) {
        return (<tr style={{ fontSize: '10px', textAlign: 'center' }}>
            <td > {props.firstColumnText} </td>
            <td >
                <div className="meter-wrap">
                    <div className="meter-value" style={{ width: barWidth }} />
                    <div className="meter-text">{props.numberOf} of {props.totalOf}</div>
                </div>
            </td>

        </tr>);
    }
    return null;
}

ExperimentPanel.propTypes = {
    /** a number 0 or 1 used to display alternative background colors */
    backgroundColorCode: PropTypes.number,
    /** the experiment type */
    experimentType: PropTypes.oneOf(['HPLC']),
}


// WEBPACK FOOTER //
// ./src/components/saxs/ExperimentPanel.js